import StoreEventFeedItem from '../../types/StoreEventFeedItem'

export default function filterAndSortFeedItems(prevFeedState: Array<StoreEventFeedItem>, newFeedItem: StoreEventFeedItem){
  return  [
    ...prevFeedState.filter((item) => item.id !== newFeedItem.id),
    ...(newFeedItem.sessionState !== 'Exited' ? [newFeedItem] : [])
  ].sort((a, b) => {
    return new Date(b.latestActivity).getTime() - new Date(a.latestActivity).getTime()
  })
}